import { createTypes } from '../../utils/helpers';

const KIOSK_FETCH_KIOSK_TYPES: any = createTypes('KIOSK_FETCH_KIOSK_TYPES');
export { KIOSK_FETCH_KIOSK_TYPES };
